import axios from "axios";

var instance = axios.create({
    baseURL: window.location.origin,
});

export default {
    namespaced: true,
    state: {
        syncResult: null,
        isSyncing: false,
        syncParams: {
            dateFrom: null,
            dateTo: null,
            dateAsOf: null,
        }
    },
    mutations: {
        SET_SyncResult(state, data) {
            state.syncResult = data;
        },
        SET_IsSyncing(state, status) {
            state.isSyncing = status;
        },
        SET_SyncParams(state, params) {
            state.syncParams = params;
        },
        RESET_SyncParams(state) {
            state.syncParams = {
                dateFrom: null,
                dateTo: null,
                dateAsOf: null,
            };
        },
        RESET_SyncResult(state) {
            state.syncResult = null;
        }
    },
    getters: {
        syncResult(state) {
            return state.syncResult;
        },
        isSyncing(state) {
            return state.isSyncing;
        },
        syncParams(state) {
            return state.syncParams;
        }
    },
    actions: {
        SyncSummitToTemp({ state, commit, rootGetters }) {
            var params = state.syncParams;

            return new Promise((resolve, reject) => {
                const queryParams = new URLSearchParams();
                
                if (params.dateFrom) {
                    queryParams.append('dateFrom', params.dateFrom);
                }
                if (params.dateTo) {
                    queryParams.append('dateTo', params.dateTo);
                }
                if (params.dateAsOf) {
                    queryParams.append('dateAsOf', params.dateAsOf);
                }

                const url = `api/integration/sync-summit-to-temp${queryParams.toString() ? '?' + queryParams.toString() : ''}`;

                commit('SET_IsSyncing', true);

                instance
                    .post(url, {}, {
                        headers: {
                            Authorization: "Bearer " + rootGetters.token,
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(async function (response) {
                        commit('SET_SyncResult', response.data);
                        commit('SET_IsSyncing', false);
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        commit('SET_IsSyncing', false);
                        reject(error.response);
                    });
            });
        },
        SetSyncParams({ commit }, params) {
            commit('SET_SyncParams', params);
        },
        ResetSyncParams({ commit }) {
            commit('RESET_SyncParams');
        },
        ResetSyncResult({ commit }) {
            commit('RESET_SyncResult');
        }
    },
    modules: {},
};